import { useLocation } from 'react-router';
import { shallowEqual, useSelector } from 'react-redux';
import SystemMessage from 'client/components/aria/SystemMessage/SystemMessage';
import { selectMessagesByLocation } from 'client/store/systemMessageSlice/systemMessageSlice';
import {
    HOME_PAGE,
    MAP_PAGE,
    BOOKMARKS_PAGE,
    OBSERVATIONS_PAGE,
    NETWORK_COVERAGE_PAGE,
    ENQUIRIES_PAGE,
    WORKPACKS_PAGE
} from 'client/utils/routes/routeConstants';

/**
 * Component that displays system messages based on the current location
 * Maps route paths to message locations for the CMS system
 * Uses Redux state populated by useSystemMessages hook in Layout.js
 */
const SystemMessageDisplay = () => {
    const location = useLocation();

    // Map route paths to CMS message locations
    const getMessageLocation = (pathname) => {
        if (pathname === HOME_PAGE) {
            return 'home';
        }
        if (pathname === MAP_PAGE) {
            return 'map';
        }
        if (pathname.startsWith(BOOKMARKS_PAGE)) {
            return 'bookmarks';
        }
        if (pathname.startsWith(OBSERVATIONS_PAGE)) {
            return 'observations';
        }
        if (pathname.startsWith(ENQUIRIES_PAGE) || pathname.startsWith(WORKPACKS_PAGE)) {
            return 'enquiries';
        }
        if (pathname.startsWith(WORKPACKS_PAGE)) {
            return 'workpacks';
        }
        if (pathname.startsWith(NETWORK_COVERAGE_PAGE)) {
            return 'coverage';
        }
        return null;
    };

    const messageLocation = getMessageLocation(location.pathname);
    const messages = useSelector(selectMessagesByLocation(messageLocation || ''), shallowEqual);

    // Only render if we have a valid location and messages
    // Note: messages without a location field will be included for all valid pages
    if (!messageLocation || !messages.length) {
        return null;
    }

    return (
        <div data-testid={messageLocation ? `systemMessageDisplay.${messageLocation}` : 'systemMessageDisplay'}>
            {messages.map((message) => (
                <SystemMessage
                    key={message.id || `${message.messageType}-${message.location || 'global'}`}
                    message={message}
                />
            ))}
        </div>
    );
};

export default SystemMessageDisplay;
